import React from 'react';
import { debounce } from 'lodash';
import { StatusToast } from '@fiverr-private/orca';
import { I18n } from '@fiverr-private/i18n-react';

/** @param {React.ReactNode=} errorMessage */
export const raiseError = debounce((errorMessage) =>
    StatusToast.raise({
        message: errorMessage || <I18n k="freelancer_page.toast.error" />,
        theme: StatusToast.THEMES.ERROR,
    })
);
